import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  List,
  useListRepository,
  DatePicker,
  useFilter,
  Filter,
  TextField
} from 'elentari'
import Snackbar from '../../components/CustomSnackbar'
import logsRepository from './logsRepository'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import moment from 'moment'
import * as R from 'ramda'
import { downloadCsv } from '../../utils/DownloadCsv'
import { useLocation, useHistory } from 'react-router-dom'
import UsuarioAutocomplete from '../Usuarios/UsuarioAutocomplete'
import { isJson } from '../../utils/Utils'
import AlertDialog from '../../components/AlertDialog'

const LogsFilter = () => {
  const filter = useFilter({})

  const initialValues = {
    dataInicio: moment()
      .second(0)
      .minute(0)
      .hour(0)
      .subtract(90, 'days')
      .format('YYYY-MM-DD HH:mm:ss')
  }

  const { push } = useHistory()

  useEffect(() => {
    const newParams = new URLSearchParams(initialValues)
    push(`/logs?${newParams}`)
  }, [push])

  return (
    <Filter
      {...filter}
      initialValues={initialValues}
      labels={{ find: 'Buscar', clear: 'Limpar' }}
    >
      <Grid container spacing={3}>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="dataInicio"
            label="Data Início"
            component={DatePicker}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="dataFim"
            label="Data Fim"
            component={DatePicker}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="consulta"
            label="Consulta"
            component={TextField}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="usuarioId"
            label="Usuário"
            component={UsuarioAutocomplete}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const Logs = ({ classes, history, ...props }) => {
  const [mensagem, setMensagem] = useState('')
  const [modal, setModal] = useState({ open: false, item: {} })
  const location = useLocation()
  const [ability] = useAbility()

  const formatPayload = payload => {
    if (isJson(payload)) {
      const parsed = JSON.parse(payload)
      return JSON.stringify({
        cpf: parsed.cpf,
        placa: parsed.placa,
        cpfcnpj: parsed.cpfcnpj,
        where: parsed.where
      })
    }
    return ''
  }

  const listOptions = {
    defaultOrder: 'id desc',
    fields: {
      createdAt: {
        label: 'Data',
        format: data => moment(data).format('DD/MM/YYYY HH:mm:ss')
      },
      acao: {
        label: 'Ação'
      },
      modelo: {
        label: 'Modelo'
      },
      recursoId: {
        label: 'Id',
        format: r => r || '-'
      },
      payload: {
        label: 'Payload',
        format: p => formatPayload(p)
      },
      usuario: {
        label: 'Usuário',
        format: u => u.usuario
      }
    }
  }

  const listHook = useListRepository({
    repository: logsRepository,
    defaultSort: 'id desc',
    path: 'logs'
  })
  const actions = getListActions(ability, listHook, 'logs')

  const onDownloadClick = async () => {
    setMensagem('Preparando download')
    const params = new URLSearchParams(location.search)
    const { page, rows, sort = 'id desc', ...allQuery } = R.fromPairs([
      ...params.entries()
    ])
    const response = await logsRepository.list({
      query: {
        ...allQuery,
        ...(sort ? { sort } : {})
      }
    })
    if (response.ok) {
      const list = response.data
      await downloadCsv(list, listOptions, true, true, 'Logs')
      setMensagem('')
    } else {
      setMensagem('Falha ao fazer download!')
    }
  }

  return (
    <>
      <LogsFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        onClickEdit={null}
        onClickNew={null}
        onClickView={item => setModal({ open: true, item })}
        flatOnDownload
        csvSeparator=";"
        onDownloadClick={onDownloadClick}
        removeItem={null}
        listOptions={listOptions}
      />
      <AlertDialog
        title="Payload"
        open={modal.open}
        handleClose={() => setModal({ open: false, item: {} })}
        closeButtonText="Fechar"
        message={modal.item.payload}
        primaryAction={() => setModal({ open: false, item: {} })}
      />
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </>
  )
}

export default Logs
